import Rails from '@rails/ujs';
import jquery from 'jquery';
import 'popper.js';
import * as bootstrap from 'bootstrap';
import { Sidebar, Navigation } from '@coreui/coreui';

const { Tooltip } = bootstrap;
import 'perfect-scrollbar';
import 'cocoon-js';
import { WysiwygEditor, WysiwygImageEditor, WysiwygFullEditor, PrivacyConsentWysiwygEditor } from '@js/modules/wysiwyg_editor/index';
import DocumentCheck from '@js/modules/documentCheck/index';
import NumberFieldsCount from '@js/modules/numberFieldsCount/index';
import NumberFieldsAssign from '@js/modules/numberFieldsAssign/index';
import AssignLock from '@js/modules/assignLock/index';
import TargetAmount from '@js/modules/targetAmount/index';
import CalculateInterestRate from '@js/modules/calculateInterestRate/index';
import PartnershipType from '@js/modules/partnershipType/index';
import CalculateFinancialStatement from '@js/modules/calculateFinancialStatement/index';
import CustomerSearch from '@js/modules/customerSearch/index';
import InputSwitch from '@js/modules/inputSwitch/index';
import DeliverEmailModal from '@js/modules/deliverEmailModal/index';
import FileUpload from '@js/modules/fileUpload/index';
import GmoConfirmationCheck from '@js/modules/gmoConfirmationCheck/index';
import TextCopy from '@js/modules/textCopy/index';
import CurrencyFormatter from '@js/modules/currencyFormatter/index';
import DividendAdjustments from '@js/modules/dividendAdjustments/index';
// 修正依頼モーダル機能
import '../javascripts/admin/revision_request_modal';
// ダッシュボード機能
import '../javascripts/admin/dashboard';
import ProjectDocumentCategory from '@js/modules/projectDocumentCategory/index';
import '../javascripts/components/assignment_documents';

// stimulus
import { Application } from '@hotwired/stimulus';
import { registerControllers } from '@js/utils/stimulus';

const application = Application.start();
const controllers = import.meta.glob('../javascripts/controllers/admin/**/*_controller.js', { eager: true });
registerControllers(application, controllers);

// $をグローバルに
window.$ = jquery;

Rails.start();

if(document.getElementById('jsWysiwygEditor')) {
  new WysiwygEditor();
}

if(document.getElementById('jsWysiwygImageEditor')) {
  new WysiwygImageEditor();
}

if(document.getElementById('jsWysiwygFullEditor')) {
  new WysiwygFullEditor();
}

if(document.getElementById('jsPrivacyConsentWysiwygEditor')) {
  new PrivacyConsentWysiwygEditor();
}

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new Tooltip(el));

const sidebarEl = document.getElementById('sidebar');
if (sidebarEl) {
  Sidebar.getOrCreateInstance(sidebarEl);
}
document.querySelectorAll('.sidebar-nav').forEach((el) => Navigation.getOrCreateInstance(el));

if(document.querySelector('.search-customer')) {
  new CustomerSearch().attachEvent();
}

if(document.getElementById('financialStatementForm')) {
  new CalculateFinancialStatement().attachEvent();
}

if(document.getElementById('applicationSelectionFile')) {
  document.getElementById('applicationSelectionFile').onchange = function() {
    document.getElementById('applicationSelectionForm').submit();
  };
}

new DocumentCheck().multipleAttachEvent();
new NumberFieldsCount().attachEvent();
new NumberFieldsAssign().attachEvent();
new AssignLock().attachEvent();
new PartnershipType().attachEvent();
new TargetAmount().attachEvent();
new CalculateInterestRate().attachEvent();
new InputSwitch().attachEvent();
new DeliverEmailModal().attachEvent();
new FileUpload().attachEvent();
new GmoConfirmationCheck().attachEvent();
new TextCopy().attachEvent();
new CurrencyFormatter().attachEvent();
new ProjectDocumentCategory().attachEvent();
new DividendAdjustments().attachEvent();
